<!--
  -- Created by zed on 2021/9/20
  -- Copyright © 2017 www.moemone.com. All rights reserved.
  --
  -- 【导航栏】，展示企业LOGO、语言切换、菜单列表等
-->
<template>
  <div class="navigation-container">
    <!-- 左侧LOGO -->
    <div class="logo-wrap">
      <img :src="mobileLogo" alt="">
    </div>
    <div class="menu">
      <span v-for="(item, index) in navItems" :key="index" class="menu-item">
        <a class="el-zp" @click="moveToPage(item.anchor)">{{ item.title }}</a>
        <span v-if="index < navItems.length - 1">|</span>
      </span>
    </div>
  </div>
</template>

<script>
import { NAV_ITEMS } from "@/settings"
import { mapGetters } from "vuex"
import { getters } from "@/store/helper"

export default {
  name: "NavigationBar",
  data() {
    return {
      mobileLogo: null,
      mobileLogoDark: null,
      navItems: NAV_ITEMS,
    }
  },
  computed: {
    ...mapGetters({
      developerMap: getters.site.developer,
    })
  },
  watch: {
    developerMap(newVal) {
      this.mobileLogo = newVal.mobileLogo
      this.mobileLogoDark = newVal.mobileLogoDark
    }
  },
  methods: {
    moveToPage(anchor) {
      // eslint-disable-next-line no-undef
      fullpage_api.moveTo(anchor)
    }
  },
}
</script>

<style lang="scss" scoped>
.navigation-container {
  height: 4rem;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .logo-wrap {
    img {
      height: 100%;
    }
  }

  .menu {
    height: 100%;

    .menu-item {
      font-size: 1.1rem;
      line-height: 4rem;
      color: #999999;
      span {
        margin: 0 1rem;
      }

      &:hover {
        color: #666666;
      }
    }
  }
}
</style>
